<template>
  <img
    :src="logo"
    class="rounded-full logo"
  >
</template>

<script>
import { KERALA_PUBLIC_LOGO } from '../constants';

export default {
  name: 'BaseRoundLogo',
  props: {
    logo: {
      type: String,
      default: KERALA_PUBLIC_LOGO,
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  height: 60px;
  width: 60px;
  box-shadow: inset 0 0 0 1px rgba(0,0,0,.08);
}
</style>
